/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_TitleInputs */

const en_us2_body_assessment_consent_title = /** @type {(inputs: Body_Assessment_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos for your body estimate`)
};

const pt_br2_body_assessment_consent_title = /** @type {(inputs: Body_Assessment_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos para estimar a sua composição corporal`)
};

const es_419_body_assessment_consent_title = /** @type {(inputs: Body_Assessment_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos para estimar tu composición corporal`)
};

const pt_pt2_body_assessment_consent_title = /** @type {(inputs: Body_Assessment_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos para estimar a tua composição corporal`)
};

const fr_fr2_body_assessment_consent_title = /** @type {(inputs: Body_Assessment_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos pour estimer ta composition corporelle`)
};

const de_de2_body_assessment_consent_title = /** @type {(inputs: Body_Assessment_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos für deine Körperschätzung`)
};

const it_it2_body_assessment_consent_title = /** @type {(inputs: Body_Assessment_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto per stimare la tua composizione corporea`)
};

/**
* | output |
* | --- |
* | "Photos for your body estimate" |
*
* @param {Body_Assessment_Consent_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_title = /** @type {((inputs?: Body_Assessment_Consent_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_title(inputs)
	return en_us2_body_assessment_consent_title(inputs)
});
export { body_assessment_consent_title as "body-assessment.consent_title" }